import { render, staticRenderFns } from "./CollapsibleContentSection.vue?vue&type=template&id=e798622c&scoped=true&"
import script from "./CollapsibleContentSection.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContentSection.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleContentSection.vue?vue&type=style&index=0&id=e798622c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e798622c",
  null
  
)

export default component.exports